var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import EditableSection from 'components/v2/EditableSection';
import Select from 'components/v2/select';
const Commercial = ({ data, onUpdateCarrier, className }) => {
    const { t } = useTranslation();
    const [initialData, setInitialData] = useState({});
    const [commercialData, setCommericalData] = useState({});
    const getInitData = () => {
        if (data) {
            setInitialData(data);
            setCommericalData(data);
        }
    };
    useEffect(() => {
        getInitData();
    }, [data]);
    const onChange = (field, value) => {
        setCommericalData((prev) => (Object.assign(Object.assign({}, prev), { [field]: value })));
    };
    const handleSave = async () => {
        const updates = {};
        const changed = __rest(commercialData, []);
        Object.keys(changed).forEach((key) => {
            if (initialData[key] !== changed[key]) {
                updates[key] = changed[key];
            }
        });
        if (Object.keys(updates).length) {
            await onUpdateCarrier(updates);
        }
    };
    const handleAfterSave = (onSaveSuccess) => {
        return (updatedData = {}) => {
            setInitialData((prev) => (Object.assign(Object.assign({}, prev), updatedData)));
            onSaveSuccess();
        };
    };
    return (React.createElement(EditableSection, { title: t('COMMERCIAL'), className: classNames(className), canEdit: true }, (editing, saving, onSaveSuccess, onSaveFail) => !editing ? (React.createElement(CommercialSummary, { fields: initialData })) : (React.createElement(CommercialForm, { fields: commercialData, onChange: onChange, onSaveCarrier: () => handleSave(), saving: saving, onSaveSuccess: handleAfterSave(onSaveSuccess), onSaveFail: onSaveFail }))));
};
const CommercialSummary = ({ fields = {} }) => {
    const { t } = useTranslation();
    const { capacity_rate_manager } = fields;
    const na = t('NONE');
    return (React.createElement("div", { className: "grid grid-cols-1 gap-4" },
        React.createElement(DescriptionListItem, { label: t('CAPACITY_RATE_MANAGER') }, capacity_rate_manager || na)));
};
const CommercialForm = ({ fields, onChange, saving, onSaveCarrier, onSaveSuccess, onSaveFail, }) => {
    const { t } = useTranslation();
    const saveForm = async () => {
        try {
            await onSaveCarrier();
            onSaveSuccess(fields);
        }
        catch (e) {
            onSaveFail();
        }
    };
    useEffect(() => {
        if (saving) {
            saveForm();
        }
    }, [saving]);
    const { admins } = fields;
    return (React.createElement("div", { className: "grid gap-4" },
        React.createElement(Select, { items: admins, valueKey: "slug", textKey: "name", selected: fields.capacity_rate_manager, onSelect: ({ slug }) => onChange('capacity_rate_manager', slug), info: t('CAPACITY_RATE_MANAGER_REPRESENTATIVE'), label: t('CAPACITY_RATE_MANAGER'), inputClassNames: "lg:w-4/5 w-1/2" })));
};
export default Commercial;
